import { Box, Button, Center, Heading, Link } from "@chakra-ui/react";
import React, { Component } from "react";
import "./Loader.css";
const error = require("./../assets/images/jobErrorIcon.png").default;
export interface loginFailedProps {
  errorTitle: string;
  closeDialog: Function;
}
export default class LoginFailed extends Component<loginFailedProps, {}> {
  /*constructor(props: loginFailedProps) {
        super(props);
    }*/
  render() {
    return (
      <Center className="defaultBG">
        <Box
          maxW={["sm", null, "4xl"]}
          p={12}
          bg="white"
          boxShadow="lg"
          m="auto"
          borderRadius="md"
        >
          <Heading>{this.props.errorTitle}</Heading>
          <Center m={4}>
            <img className="jobError" alt="Job Error" src={error}></img>
          </Center>
          {/* <Link href="https://portal.flowautobody.com.au/"> */}
          <Button
            w="100%"
            colorScheme={"blue"}
            variant="outline"
            onClick={() => this.props.closeDialog()}
          >
            Close
          </Button>
          <Box mt={8} w="100%">
            <Box mb={4}>
              Please check your details
              <br />
              and try again or contact
              <br />
              customer support at
            </Box>
            <Link href="mailto:hello@flowautobody.com.au">
              hello@flowautobody.com.au
            </Link>
          </Box>
        </Box>
      </Center>
    );
  }
}
